import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { profileApi } from './api'

export function useProfile() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'profile'),
    queryFn: profileApi.get,
    // Why: useReportBrand() pulls profile data from chat-message renderers
    // that also mount on the public /chat/share/:token page. Skip the
    // request when no tenant is in scope so an unauthenticated viewer
    // doesn't trigger a 401-driven redirect.
    enabled: !!tenantId,
  })
}

export function useUpdateName() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (name: string) => profileApi.updateName(name),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'profile') }),
  })
}

export function useUploadImage() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (file: File) => profileApi.uploadImage(file),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'profile') }),
  })
}

export function useRequestDeleteCode() {
  return useMutation({ mutationFn: () => profileApi.requestDeleteCode() })
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: (code: string) => profileApi.deleteAccount(code),
  })
}

export function useLeaveCurrentWorkspace() {
  return useMutation({
    mutationFn: () => profileApi.leaveCurrentWorkspace(),
  })
}
